"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _Switch = _interopRequireDefault(require("../switch/Switch"));

var _excluded = ["isChecked", "className", "label", "onChange"];

var TreeOption = function TreeOption(props) {
  var isChecked = props.isChecked,
      className = props.className,
      label = props.label,
      onChange = props.onChange,
      remainingProps = (0, _objectWithoutProperties2.default)(props, _excluded);
  var optionClasses = (0, _classnames.default)('TreeOption', 'display-flex', 'justify-content-start', 'cursor-pointer', className);
  return /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, remainingProps, {
    className: optionClasses,
    onClick: onChange
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: 'pointer-events-none scale-80'
  }, /*#__PURE__*/_react.default.createElement(_Switch.default, {
    keyName: 'TreeOption-switch',
    checked: isChecked
  })), /*#__PURE__*/_react.default.createElement("span", {
    className: 'margin-left-5 padding-top-2'
  }, label));
};

TreeOption.displayName = 'TreeOption';
TreeOption.defaultProps = {
  isChecked: false,
  onChange: function onChange() {}
};
TreeOption.propTypes = {
  isChecked: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]).isRequired,
  className: _propTypes.default.string
};
var _default = TreeOption;
exports.default = _default;